import request from '@/utils/request'

let Ma_emergency_suppliesApi = {

  /*应急物资列表*/
  list(data) {
    return request._post('/shop/plus.ma_emergency_supplies.Index/index', data);
},
/*添加应急物资*/
add(data) {
    return request._post('/shop/plus.ma_emergency_supplies.Index/add', data);
},
/*修改应急物资*/
edit(data) {
    return request._post('/shop/plus.ma_emergency_supplies.Index/edit', data);
},
/*删除应急物资*/
del(data) {
    return request._post('/shop/plus.ma_emergency_supplies.Index/del', data);
},
/*应急物资详情*/
detail(data) {
  return request._post('/shop/plus.ma_emergency_supplies.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_emergency_supplies.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_emergency_supplies.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_emergency_supplies.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_emergency_supplies.Index/export', data);
    },
}
export default Ma_emergency_suppliesApi;



// WEBPACK FOOTER //
// ./src/api/ma_emergency_supplies.js